<template>
  <svg width="32"
       height="32"
       viewBox="0 0 32 32"
       fill="none"
       xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_7501_5320)">
      <path d="M2.57469 5.33511L8.75034 3.57338C8.92966 3.52223 9.11971 3.52223 9.29903 3.57339L15.7556 5.41549C15.935 5.46669 16.1252 5.46665 16.3047 5.41537L22.7497 3.57369C22.9294 3.52234 23.1199 3.52237 23.2996 3.57379L29.4547 5.33511C29.7547 5.41511 29.9647 5.68512 29.9647 5.99512V27.8151C29.9647 28.2551 29.5447 28.5851 29.1147 28.4751L23.3242 26.5925C23.135 26.531 22.9319 26.5273 22.7406 26.5819L16.3097 28.4167C16.1299 28.4679 15.9394 28.4678 15.7597 28.4163L9.31869 26.5694C9.12707 26.5145 8.9234 26.5181 8.73383 26.5797L2.90469 28.4751C2.47469 28.5851 2.05469 28.2551 2.05469 27.8151V5.99512C2.05469 5.68512 2.27469 5.41511 2.57469 5.33511Z"
            fill="url(#paint0_linear_7501_5320)"
      />
      <path d="M2.57469 5.33511L8.75034 3.57338C8.92966 3.52223 9.11971 3.52223 9.29903 3.57339L15.7556 5.41549C15.935 5.46669 16.1252 5.46665 16.3047 5.41537L22.7497 3.57369C22.9294 3.52234 23.1199 3.52237 23.2996 3.57379L29.4547 5.33511C29.7547 5.41511 29.9647 5.68512 29.9647 5.99512V27.8151C29.9647 28.2551 29.5447 28.5851 29.1147 28.4751L23.3242 26.5925C23.135 26.531 22.9319 26.5273 22.7406 26.5819L16.3097 28.4167C16.1299 28.4679 15.9394 28.4678 15.7597 28.4163L9.31869 26.5694C9.12707 26.5145 8.9234 26.5181 8.73383 26.5797L2.90469 28.4751C2.47469 28.5851 2.05469 28.2551 2.05469 27.8151V5.99512C2.05469 5.68512 2.27469 5.41511 2.57469 5.33511Z"
            fill="url(#paint1_linear_7501_5320)"
      />
      <path d="M2.57469 5.33511L8.75034 3.57338C8.92966 3.52223 9.11971 3.52223 9.29903 3.57339L15.7556 5.41549C15.935 5.46669 16.1252 5.46665 16.3047 5.41537L22.7497 3.57369C22.9294 3.52234 23.1199 3.52237 23.2996 3.57379L29.4547 5.33511C29.7547 5.41511 29.9647 5.68512 29.9647 5.99512V27.8151C29.9647 28.2551 29.5447 28.5851 29.1147 28.4751L23.3242 26.5925C23.135 26.531 22.9319 26.5273 22.7406 26.5819L16.3097 28.4167C16.1299 28.4679 15.9394 28.4678 15.7597 28.4163L9.31869 26.5694C9.12707 26.5145 8.9234 26.5181 8.73383 26.5797L2.90469 28.4751C2.47469 28.5851 2.05469 28.2551 2.05469 27.8151V5.99512C2.05469 5.68512 2.27469 5.41511 2.57469 5.33511Z"
            fill="url(#paint2_linear_7501_5320)"
      />
      <path d="M2.57469 5.33511L8.75034 3.57338C8.92966 3.52223 9.11971 3.52223 9.29903 3.57339L15.7556 5.41549C15.935 5.46669 16.1252 5.46665 16.3047 5.41537L22.7497 3.57369C22.9294 3.52234 23.1199 3.52237 23.2996 3.57379L29.4547 5.33511C29.7547 5.41511 29.9647 5.68512 29.9647 5.99512V27.8151C29.9647 28.2551 29.5447 28.5851 29.1147 28.4751L23.3242 26.5925C23.135 26.531 22.9319 26.5273 22.7406 26.5819L16.3097 28.4167C16.1299 28.4679 15.9394 28.4678 15.7597 28.4163L9.31869 26.5694C9.12707 26.5145 8.9234 26.5181 8.73383 26.5797L2.90469 28.4751C2.47469 28.5851 2.05469 28.2551 2.05469 27.8151V5.99512C2.05469 5.68512 2.27469 5.41511 2.57469 5.33511Z"
            fill="url(#paint3_radial_7501_5320)"
      />
      <path d="M2.57469 5.33511L8.75034 3.57338C8.92966 3.52223 9.11971 3.52223 9.29903 3.57339L15.7556 5.41549C15.935 5.46669 16.1252 5.46665 16.3047 5.41537L22.7497 3.57369C22.9294 3.52234 23.1199 3.52237 23.2996 3.57379L29.4547 5.33511C29.7547 5.41511 29.9647 5.68512 29.9647 5.99512V27.8151C29.9647 28.2551 29.5447 28.5851 29.1147 28.4751L23.3242 26.5925C23.135 26.531 22.9319 26.5273 22.7406 26.5819L16.3097 28.4167C16.1299 28.4679 15.9394 28.4678 15.7597 28.4163L9.31869 26.5694C9.12707 26.5145 8.9234 26.5181 8.73383 26.5797L2.90469 28.4751C2.47469 28.5851 2.05469 28.2551 2.05469 27.8151V5.99512C2.05469 5.68512 2.27469 5.41511 2.57469 5.33511Z"
            fill="url(#paint4_radial_7501_5320)"
      />
      <path d="M2.57469 5.33511L8.75034 3.57338C8.92966 3.52223 9.11971 3.52223 9.29903 3.57339L15.7556 5.41549C15.935 5.46669 16.1252 5.46665 16.3047 5.41537L22.7497 3.57369C22.9294 3.52234 23.1199 3.52237 23.2996 3.57379L29.4547 5.33511C29.7547 5.41511 29.9647 5.68512 29.9647 5.99512V27.8151C29.9647 28.2551 29.5447 28.5851 29.1147 28.4751L23.3242 26.5925C23.135 26.531 22.9319 26.5273 22.7406 26.5819L16.3097 28.4167C16.1299 28.4679 15.9394 28.4678 15.7597 28.4163L9.31869 26.5694C9.12707 26.5145 8.9234 26.5181 8.73383 26.5797L2.90469 28.4751C2.47469 28.5851 2.05469 28.2551 2.05469 27.8151V5.99512C2.05469 5.68512 2.27469 5.41511 2.57469 5.33511Z"
            fill="url(#paint5_radial_7501_5320)"
      />
      <path d="M2.57469 5.33511L8.75034 3.57338C8.92966 3.52223 9.11971 3.52223 9.29903 3.57339L15.7556 5.41549C15.935 5.46669 16.1252 5.46665 16.3047 5.41537L22.7497 3.57369C22.9294 3.52234 23.1199 3.52237 23.2996 3.57379L29.4547 5.33511C29.7547 5.41511 29.9647 5.68512 29.9647 5.99512V27.8151C29.9647 28.2551 29.5447 28.5851 29.1147 28.4751L23.3242 26.5925C23.135 26.531 22.9319 26.5273 22.7406 26.5819L16.3097 28.4167C16.1299 28.4679 15.9394 28.4678 15.7597 28.4163L9.31869 26.5694C9.12707 26.5145 8.9234 26.5181 8.73383 26.5797L2.90469 28.4751C2.47469 28.5851 2.05469 28.2551 2.05469 27.8151V5.99512C2.05469 5.68512 2.27469 5.41511 2.57469 5.33511Z"
            fill="url(#paint6_radial_7501_5320)"
      />
      <path d="M2.57469 5.33511L8.75034 3.57338C8.92966 3.52223 9.11971 3.52223 9.29903 3.57339L15.7556 5.41549C15.935 5.46669 16.1252 5.46665 16.3047 5.41537L22.7497 3.57369C22.9294 3.52234 23.1199 3.52237 23.2996 3.57379L29.4547 5.33511C29.7547 5.41511 29.9647 5.68512 29.9647 5.99512V27.8151C29.9647 28.2551 29.5447 28.5851 29.1147 28.4751L23.3242 26.5925C23.135 26.531 22.9319 26.5273 22.7406 26.5819L16.3097 28.4167C16.1299 28.4679 15.9394 28.4678 15.7597 28.4163L9.31869 26.5694C9.12707 26.5145 8.9234 26.5181 8.73383 26.5797L2.90469 28.4751C2.47469 28.5851 2.05469 28.2551 2.05469 27.8151V5.99512C2.05469 5.68512 2.27469 5.41511 2.57469 5.33511Z"
            fill="url(#paint7_radial_7501_5320)"
      />
      <path d="M2.57469 5.33511L8.75034 3.57338C8.92966 3.52223 9.11971 3.52223 9.29903 3.57339L15.7556 5.41549C15.935 5.46669 16.1252 5.46665 16.3047 5.41537L22.7497 3.57369C22.9294 3.52234 23.1199 3.52237 23.2996 3.57379L29.4547 5.33511C29.7547 5.41511 29.9647 5.68512 29.9647 5.99512V27.8151C29.9647 28.2551 29.5447 28.5851 29.1147 28.4751L23.3242 26.5925C23.135 26.531 22.9319 26.5273 22.7406 26.5819L16.3097 28.4167C16.1299 28.4679 15.9394 28.4678 15.7597 28.4163L9.31869 26.5694C9.12707 26.5145 8.9234 26.5181 8.73383 26.5797L2.90469 28.4751C2.47469 28.5851 2.05469 28.2551 2.05469 27.8151V5.99512C2.05469 5.68512 2.27469 5.41511 2.57469 5.33511Z"
            fill="url(#paint8_radial_7501_5320)"
      />
      <path d="M2.57469 5.33511L8.75034 3.57338C8.92966 3.52223 9.11971 3.52223 9.29903 3.57339L15.7556 5.41549C15.935 5.46669 16.1252 5.46665 16.3047 5.41537L22.7497 3.57369C22.9294 3.52234 23.1199 3.52237 23.2996 3.57379L29.4547 5.33511C29.7547 5.41511 29.9647 5.68512 29.9647 5.99512V27.8151C29.9647 28.2551 29.5447 28.5851 29.1147 28.4751L23.3242 26.5925C23.135 26.531 22.9319 26.5273 22.7406 26.5819L16.3097 28.4167C16.1299 28.4679 15.9394 28.4678 15.7597 28.4163L9.31869 26.5694C9.12707 26.5145 8.9234 26.5181 8.73383 26.5797L2.90469 28.4751C2.47469 28.5851 2.05469 28.2551 2.05469 27.8151V5.99512C2.05469 5.68512 2.27469 5.41511 2.57469 5.33511Z"
            fill="url(#paint9_radial_7501_5320)"
      />
      <path d="M2.57469 5.33511L8.75034 3.57338C8.92966 3.52223 9.11971 3.52223 9.29903 3.57339L15.7556 5.41549C15.935 5.46669 16.1252 5.46665 16.3047 5.41537L22.7497 3.57369C22.9294 3.52234 23.1199 3.52237 23.2996 3.57379L29.4547 5.33511C29.7547 5.41511 29.9647 5.68512 29.9647 5.99512V27.8151C29.9647 28.2551 29.5447 28.5851 29.1147 28.4751L23.3242 26.5925C23.135 26.531 22.9319 26.5273 22.7406 26.5819L16.3097 28.4167C16.1299 28.4679 15.9394 28.4678 15.7597 28.4163L9.31869 26.5694C9.12707 26.5145 8.9234 26.5181 8.73383 26.5797L2.90469 28.4751C2.47469 28.5851 2.05469 28.2551 2.05469 27.8151V5.99512C2.05469 5.68512 2.27469 5.41511 2.57469 5.33511Z"
            fill="url(#paint10_radial_7501_5320)"
      />
      <path d="M4.00512 6.83511L8.63908 5.62168C8.89837 5.55378 9.17112 5.5566 9.42895 5.62985L15.587 7.37919C15.8539 7.455 16.1365 7.45531 16.4035 7.38011L22.6301 5.6264C22.8887 5.55356 23.1621 5.55152 23.4218 5.62048L27.9951 6.83513C28.2951 6.91513 28.5051 7.18513 28.5051 7.49513V25.6676C28.5051 25.8864 28.3911 26.1833 28.0396 26.0895L23.4411 24.6263C23.1602 24.537 22.8593 24.5323 22.5758 24.613L16.4074 26.3679C16.1379 26.4445 15.8524 26.4442 15.5832 26.3669L9.46078 24.6101C9.1801 24.5296 8.88201 24.5327 8.60308 24.6192L4.16064 25.9958C3.82471 26.0778 3.49512 25.8989 3.49512 25.4489V7.49512C3.49512 7.18512 3.70512 6.91511 4.00512 6.83511Z"
            fill="url(#paint11_linear_7501_5320)"
      />
      <path d="M25.4658 20.4849C25.7755 20.4851 26.0252 20.7348 26.0254 21.0444V21.9946C26.0254 22.2746 25.8054 22.4946 25.5254 22.4946H23.5254C23.2454 22.4946 23.0254 22.2746 23.0254 21.9946V21.3247C23.0255 20.8648 23.3955 20.4849 23.8555 20.4849H25.4658ZM12.7246 8.50537C13.4446 8.50537 14.0254 9.08518 14.0254 9.80518C14.0253 10.2551 13.8453 10.6854 13.5254 11.0054L13.1152 11.4146C13.0552 11.4746 13.0254 11.5553 13.0254 11.6353V12.0054C13.0251 12.285 12.805 12.5051 12.5254 12.5054C12.2456 12.5054 12.0256 12.2851 12.0254 12.0054V10.0054C12.0254 9.72553 11.8052 9.50561 11.5254 9.50537C11.2454 9.50537 11.0254 9.72537 11.0254 10.0054V10.1948C11.0254 10.3648 10.8848 10.5054 10.7148 10.5054H9.93457C9.7548 10.5056 9.6151 10.6449 9.625 10.8247L9.64453 11.1753C9.65429 11.3451 9.51481 11.4946 9.33496 11.4946C9.16496 11.4946 9.02539 11.6352 9.02539 11.8052V11.9946C9.02539 12.2746 9.24539 12.4946 9.52539 12.4946C9.80517 12.4944 10.0254 12.2745 10.0254 11.9946C10.0255 11.7147 10.2455 11.4946 10.5254 11.4946C10.8051 11.4949 11.0253 11.7149 11.0254 11.9946V12.3647C11.0254 12.4447 11.0553 12.5245 11.1152 12.5845L11.8047 13.2749C11.9247 13.3949 11.9247 13.5953 11.8047 13.7153L11.5146 14.0054C11.2047 14.3151 10.7748 14.4946 10.335 14.4946C10.165 14.4946 10.0254 14.6352 10.0254 14.8052V14.9946C10.0254 15.2745 9.80517 15.4944 9.52539 15.4946C9.24539 15.4946 9.02539 15.2746 9.02539 14.9946V14.8052C9.02539 14.6352 8.88484 14.4946 8.71484 14.4946H8.33496C8.16496 14.4946 8.02539 14.6352 8.02539 14.8052V15.3647C8.02539 15.4447 8.05526 15.5245 8.11523 15.5845L9.93457 17.4048C9.99457 17.4648 10.0753 17.4946 10.1553 17.4946H10.5947C10.8747 17.4946 11.1553 17.5551 11.4053 17.6851L12.5752 18.2651C12.855 18.3952 13.0254 18.675 13.0254 18.9849C13.0254 19.2847 12.845 19.5645 12.5752 19.7046L11.3447 20.3247C11.1448 20.4247 11.0254 20.6252 11.0254 20.8452V21.9849C11.0254 22.2647 10.8052 22.4846 10.5254 22.4849C10.2555 22.4849 10.0251 22.265 10.0449 22.0151V20.645C10.0449 20.5651 10.0149 20.4853 9.95508 20.4253L9.5752 20.0444C9.23536 19.7046 9.04505 19.2352 9.04492 18.7554V17.6353C9.04492 17.5553 9.01508 17.4746 8.95508 17.4146L7.70508 16.1646C7.285 15.7446 6.04492 15.1747 6.04492 14.5747V12.2153C6.04492 11.8253 6.72488 11.5054 6.33496 11.5054C6.14496 11.5054 5.96496 11.5853 5.83496 11.7153L4.5752 12.9751C4.37531 13.165 4.04531 13.035 4.04492 12.7554V12.6245C4.04501 12.5446 4.07488 12.4647 4.13477 12.4048L4.375 12.1646C4.79486 11.7446 5.03514 11.1648 5.03516 10.5649V10.1948C5.03518 9.81495 5.34477 9.50554 5.72461 9.50537H6.34473C6.72471 9.50537 7.03513 9.81485 7.03516 10.1948C7.03516 10.3648 7.17482 10.5053 7.34473 10.5054H7.44531C7.90517 10.5053 8.34536 10.315 8.65527 9.9751L9.27539 9.30518C9.75539 8.79522 10.425 8.50537 11.125 8.50537H12.7246ZM21.3955 8.48486C21.7253 8.48493 21.9949 8.75469 21.9951 9.08447C21.9951 9.30447 22.1755 9.48486 22.3955 9.48486H23.585C23.805 9.48486 23.9854 9.30447 23.9854 9.08447V8.89502C23.9854 8.67502 24.1657 8.49463 24.3857 8.49463H24.4258C25.2755 8.49484 25.9754 9.18476 25.9756 10.0444V11.9849C25.9756 12.2648 25.7555 12.4848 25.4756 12.4849C25.1956 12.4849 24.9756 12.2649 24.9756 11.9849V11.8853C24.9756 11.6653 24.7952 11.4849 24.5752 11.4849H24.3857C24.1657 11.4849 23.9854 11.6653 23.9854 11.8853V13.0747C23.9854 13.2947 24.1657 13.4751 24.3857 13.4751C24.6655 13.4753 24.8657 13.765 24.7559 14.0249L23.875 16.2153C23.8149 16.3649 23.6655 16.4651 23.5059 16.4653H22.3857C22.1658 16.4653 21.9854 16.2849 21.9854 16.0649V15.8745C21.9852 15.6547 21.8048 15.4751 21.585 15.4751H21.3955C21.1756 15.4751 20.9953 15.6547 20.9951 15.8745V16.0649C20.9951 16.2848 20.8155 16.4652 20.5957 16.4653H20.4053C20.1854 16.4653 20.0059 16.2849 20.0059 16.0649V15.8745C20.0057 15.6547 19.8253 15.4751 19.6055 15.4751H19.415C19.1953 15.4753 19.0158 15.6548 19.0156 15.8745V16.3745C19.0156 16.4345 19.0056 16.4952 18.9756 16.5552L18.0654 18.3853C18.0355 18.4452 18.0254 18.505 18.0254 18.5649V19.8052C18.0253 20.235 17.8555 20.6449 17.5557 20.9448L17.1455 21.355C17.0655 21.435 16.9654 21.4751 16.8555 21.4751H16.4258C16.2058 21.4751 16.0254 21.2947 16.0254 21.0747V18.8853C16.0254 18.6653 15.845 18.4849 15.625 18.4849H15.1953C15.0853 18.4848 14.9853 18.4447 14.9053 18.3647L14.375 17.8345C14.1552 17.6145 14.0254 17.3047 14.0254 16.9849C14.0254 16.665 14.1453 16.3652 14.375 16.1353L14.9053 15.605C14.9853 15.535 15.0858 15.4946 15.1758 15.4546H15.6055C15.8253 15.4545 16.0057 15.275 16.0059 15.0552V14.8647C16.0058 14.6448 15.8254 14.4654 15.6055 14.4653H15.415C15.1952 14.4651 15.0157 14.2848 15.0156 14.0649V12.8745C15.0158 12.6548 15.1953 12.4753 15.415 12.4751H15.6055C15.8254 12.4751 16.0059 12.2947 16.0059 12.0747V11.8853C16.0059 11.6653 16.1853 11.4849 16.4053 11.4849H17.8457C17.9455 11.4848 18.0453 11.455 18.1152 11.3853L19.8652 9.81494C19.9452 9.73501 19.995 9.62505 19.9951 9.51514V9.48486C19.9951 8.93495 20.4452 8.48501 20.9951 8.48486H21.3955ZM22.7158 17.4653C22.8856 17.4656 23.0254 17.605 23.0254 17.7749C23.0254 18.0649 23.3754 18.1948 23.5654 17.9849L23.9355 17.5747C23.9955 17.5149 24.0753 17.4752 24.165 17.4751H25.0254C25.5754 17.4751 26.0254 17.9251 26.0254 18.4751V19.3149C26.0253 19.5149 25.8452 19.6547 25.6553 19.6147L25.4355 19.5649C25.1957 19.515 25.0255 19.295 25.0254 19.0552C25.0254 18.7452 24.7553 18.5047 24.4453 18.5347L24.2949 18.5552C24.1452 18.5754 24.0254 18.705 24.0254 18.8647V19.2349C24.0254 19.3749 23.9252 19.5047 23.7852 19.5347C23.3252 19.6446 22.8351 19.4749 22.5352 19.105L22.3252 18.855C22.1352 18.615 22.0254 18.3144 22.0254 18.0044V17.7944C22.0256 17.6248 22.1653 17.4855 22.335 17.4653H22.7158Z"
            fill="url(#paint12_linear_7501_5320)"
      />
    </g>
    <defs>
      <linearGradient id="paint0_linear_7501_5320"
                      x1="29.9647"
                      y1="15.4792"
                      x2="2.05469"
                      y2="15.4792"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#BFB1CA" />
        <stop offset="0.237699"
              stop-color="#C3B5CD"
        />
        <stop offset="0.256926"
              stop-color="#DED3E5"
        />
        <stop offset="0.487655"
              stop-color="#EBE1F1"
        />
        <stop offset="0.50777"
              stop-color="#C5B9CD"
        />
        <stop offset="0.740516"
              stop-color="#C7BCCE"
        />
        <stop offset="0.76011"
              stop-color="#EFE3F3"
        />
        <stop offset="1"
              stop-color="#E3D7E9"
        />
      </linearGradient>
      <linearGradient id="paint1_linear_7501_5320"
                      x1="13.3905"
                      y1="48.4853"
                      x2="13.3905"
                      y2="2.89521"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#C5B2D4" />
        <stop offset="1"
              stop-color="#C5B2D4"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint2_linear_7501_5320"
                      x1="2.05469"
                      y1="18.0001"
                      x2="9.25"
                      y2="18.0001"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B49FC2" />
        <stop offset="0.0792616"
              stop-color="#B49FC2"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint3_radial_7501_5320"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(2.28125 29.1251) rotate(-21.8014) scale(7.90946 0.822228)"
      >
        <stop offset="0.0667645"
              stop-color="#B49FC2"
        />
        <stop offset="1"
              stop-color="#B49FC2"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint4_radial_7501_5320"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(16.0098 28.7189) rotate(-160.511) scale(7.35292 0.764373)"
      >
        <stop offset="0.0667645"
              stop-color="#B49FC2"
        />
        <stop offset="1"
              stop-color="#B49FC2"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint5_radial_7501_5320"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(16.3437 28.9064) rotate(-20.3569) scale(7.36632 0.765766)"
      >
        <stop offset="0.0667645"
              stop-color="#B49FC2"
        />
        <stop offset="1"
              stop-color="#B49FC2"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint6_radial_7501_5320"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(29.25 28.8439) rotate(-157.38) scale(6.5 0.675707)"
      >
        <stop offset="0.0667645"
              stop-color="#B49FC2"
        />
        <stop offset="1"
              stop-color="#B49FC2"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint7_radial_7501_5320"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(19.7187 4.37512) rotate(163.583) scale(3.64877 0.511464)"
      >
        <stop stop-color="#B49FC2"
              stop-opacity="0.4"
        />
        <stop offset="1"
              stop-color="#B49FC2"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint8_radial_7501_5320"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(6.00644 4.32018) rotate(163.718) scale(4.11687 0.409801)"
      >
        <stop stop-color="#B49FC2"
              stop-opacity="0.4"
        />
        <stop offset="1"
              stop-color="#B49FC2"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint9_radial_7501_5320"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(5.76563 4.75012) rotate(164.769) scale(3.27115 0.185504)"
      >
        <stop offset="0.0667645"
              stop-color="#FFFFFF"
              stop-opacity="0.4"
        />
        <stop offset="1"
              stop-color="#FFFFFF"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint10_radial_7501_5320"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(19.6719 4.75012) rotate(163.944) scale(3.33315 0.189019)"
      >
        <stop offset="0.0667645"
              stop-color="#FFFFFF"
              stop-opacity="0.4"
        />
        <stop offset="1"
              stop-color="#FFFFFF"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint11_linear_7501_5320"
                      x1="28.5051"
                      y1="16.0001"
                      x2="3.49571"
                      y2="16.1217"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#257AC5" />
        <stop offset="0.206041"
              stop-color="#237BC8"
        />
        <stop offset="0.225408"
              stop-color="#4190DB"
        />
        <stop offset="0.485304"
              stop-color="#49A5F1"
        />
        <stop offset="0.509045"
              stop-color="#2484D0"
        />
        <stop offset="0.763942"
              stop-color="#2488D4"
        />
        <stop offset="0.787683"
              stop-color="#4AA6F6"
        />
        <stop offset="1"
              stop-color="#4BABFC"
        />
      </linearGradient>
      <linearGradient id="paint12_linear_7501_5320"
                      x1="4.04492"
                      y1="21.4889"
                      x2="26.0254"
                      y2="21.4889"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.210145"
              stop-color="#61E7A1"
        />
        <stop offset="0.23712"
              stop-color="#46C687"
        />
        <stop offset="0.532489"
              stop-color="#46BF86"
        />
        <stop offset="0.562161"
              stop-color="#5BDE9A"
        />
        <stop offset="0.849438"
              stop-color="#50CC8C"
        />
        <stop offset="0.876412"
              stop-color="#43BE81"
        />
      </linearGradient>
      <clipPath id="clip0_7501_5320">
        <rect width="32"
              height="32"
              fill="#FFFFFF"
        />
      </clipPath>
    </defs>
  </svg>
</template>
